export default __webpack_public_path__ + "static/media/inactiveUser.33e7df09.png";